import { render, staticRenderFns } from "./DrawerContainer_Right.vue?vue&type=template&id=bdc242b6&"
import script from "./DrawerContainer_Right.vue?vue&type=script&lang=js&"
export * from "./DrawerContainer_Right.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports